import { request } from '../utils/request'
import { apiURL } from '../utils/url'
import { apiRoutes } from '../routes'

export async function resetPasswordRequest(email: string): Promise<void> {
  const response = await request(apiURL(apiRoutes.resetPassword.request), {
    method: 'POST',
    body: JSON.stringify({ email }),
  })
  if (!response.ok) {
    throw new Error('Failed to request to reset a password')
  }
}

export async function resetPassword(jwt: string, password: string): Promise<void> {
  const response = await request(apiURL(apiRoutes.resetPassword.verifyAndUpdate), {
    method: 'POST',
    body: JSON.stringify({ jwt, password }),
  })
  if (!response.ok) {
    throw new Error('Failed to reset a password')
  }
}
